import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  ViewActivityEngagementRequest,
  ViewHashtagEngagementRequest,
  ViewHashtagOccurencesRequest
} from './administration.types';

export const requestViewActivityEngagement = createAction<SagaPayload<ViewActivityEngagementRequest>['payload']>(
  'request/viewActivityEngagement'
);

export const requestViewHashtagEngagement = createAction<SagaPayload<ViewHashtagEngagementRequest>['payload']>(
  'request/viewHashtagEngagement'
);

export const requestViewHashtagOccurrences = createAction<SagaPayload<ViewHashtagOccurencesRequest>['payload']>(
  'request/viewHashtagOccurrences'
);
